module.exports = __webpack_public_path__ + "static/media/bar-empty.d1c3391a.png";